/**
* @ngdoc service
* @name common.service:StatesService
* @description
* States main service
*/
(function() {
    'use strict';

    angular
    .module('itxApp.legacy')
    .service('StatesService', StatesService);

    StatesService.$inject = [
        '$q'
    ];

    function StatesService (
        $q
    ) {
        var _this = this;
        
        _this.states = [];

        var service =  {
            getStates: getStates, // se usa
            getCities:getCities, // se usa
        };

        return service;

        /**
         * @ngdoc method
         * @name getStates
         * @methodOf common.service:StatesService
         * @description
         * Get States and cache them
         * @returns {array} State's array.
         */
        function getStates (country, refresh) {
            var deferred = $q.defer();
                               
            if (_this.states.length >0 && !refresh) {
                deferred.resolve(_this.states);
                return deferred.promise;
            }
            
            var action = {
                action: 'bam:states',
                params: {
                    storeId: country || inditex.iStoreId,
                    languageId: inditex.iLangId
                }
            };
                
            joyr.rest.xRestExecute([action])
            .done(function (data) {
                _this.states = data[0].states;
                deferred.resolve(_this.states);
            })
            .Catch(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name getCities
        * @methodOf common.service:StatesService
        * @description
        * Get list of cities of given state id.
        *  @param {string} stateId - The ID/code of the state.
        */
        function getCities(stateId){
            var deferred = $q.defer();
                            
            var action = {
                action: 'bam:cities',
                params: {
                    storeId: inditex.iStoreId,
                    stateCode: stateId,
                    languageId: inditex.iLangId
                }
            };
            if(!stateId){
                delete action.params.stateCode;
            }
    
            joyr.rest.xRestExecute([action])
            .done(function (data) {
                deferred.resolve(data[0].cities);
            })
            .Catch(function(err){
                console.error(err);
                deferred.reject(err);
            });

            return deferred.promise;
        }

    }

})();
